import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { getFormInputProps } from "util/forms";
import { InputableRadioGroup, OnboardingInputControl } from "ui/molecules/Input";
import OnboardingForm from "../../OnboardingForm";
import { FormField, type OnboardingMarketingWebsiteAndSupportProps } from "./types";

const MarketingWebsiteAndSupport = ({
    values,
    isSubmitting,
    isValid,
    isBootstrapDataLoading,
    isIncomplete,
    requestedChangeFields,
    bootstrapData,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...form
}: OnboardingMarketingWebsiteAndSupportProps) => {
    return (
        <OnboardingForm
            {...form}
            isSubmitting={isSubmitting}
            isValid={isValid}
            isIncomplete={isIncomplete}
            requestedChangeFields={requestedChangeFields}
            handleSubmit={handleSubmit}
        >
            <Typography
                variant='h6'
                color='error'
            >
                Marius, none of these fields doesn't match the provided BE response shema.
                I placed them to occupy the form space.
                This step needs to be reworked according to the latest BUSINESS specs.!!!
            </Typography>
            <OnboardingInputControl
                name={FormField.HasMembershipPackages}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <InputableRadioGroup
                        slotProps={{
                            typography: {
                                children: 'Do you have a credit limit policy on your product? (if applicable)'
                            },
                            formControlLabel: {
                                disabled
                            },
                            radioGroup: {
                                'aria-labelledby': FormField.HasMembershipPackages,
                                name: FormField.HasMembershipPackages,
                                value: values[FormField.HasMembershipPackages],
                                onChange: handleChange,
                                onBlur: handleBlur
                            },
                            textField: {
                                ...getFormInputProps(FormField.MembershipPackagesInput, form),
                                disabled,
                                name: FormField.MembershipPackagesInput,
                                value: values[FormField.MembershipPackagesInput],
                                label: 'IF YES: Provide Details',
                                onChange: handleChange,
                                onBlur: handleBlur
                            }
                        }}
                    />
                )}
            />
            <Typography
                marginTop={2}
                variant='h6'
            >
                List all fraud tools used
            </Typography>
            <OnboardingInputControl
                name={FormField.MarketingMethods}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <TextField
                        {...getFormInputProps(FormField.MarketingMethods, form)}
                        required
                        multiline
                        fullWidth
                        disabled={disabled}
                        rows={4}
                        size='small'
                        name={FormField.MarketingMethods}
                        value={values[FormField.MarketingMethods]}
                        label='Comma separated list of fraud tools used'
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                )}
            />
            <OnboardingInputControl
                name={FormField.HasFreeTrial}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <InputableRadioGroup
                        slotProps={{
                            typography: {
                                children: 'Have you ever been terminated by an Acquirer?'
                            },
                            formControlLabel: {
                                disabled
                            },
                            radioGroup: {
                                'aria-labelledby': FormField.HasFreeTrial,
                                name: FormField.HasFreeTrial,
                                value: values[FormField.HasFreeTrial],
                                onChange: handleChange,
                                onBlur: handleBlur
                            },
                            textField: {
                                ...getFormInputProps(FormField.FreeTrialInput, form),
                                disabled,
                                name: FormField.FreeTrialInput,
                                value: values[FormField.FreeTrialInput],
                                label: 'IF YES: Quote the name & explain the reason',
                                onChange: handleChange,
                                onBlur: handleBlur
                            }
                        }}
                    />
                )}
            />
            <OnboardingInputControl
                name={FormField.IsForAnotherBusiness}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <InputableRadioGroup
                        slots={{
                            textField: <></>
                        }}
                        slotProps={{
                            typography: {
                                sx: {
                                    mt: 2
                                },
                                children: 'Do you collect customer KYC?'
                            },
                            formControlLabel: {
                                disabled
                            },
                            radioGroup: {
                                'aria-labelledby': FormField.IsForAnotherBusiness,
                                name: FormField.IsForAnotherBusiness,
                                value: values[FormField.IsForAnotherBusiness],
                                onChange: handleChange,
                                onBlur: handleBlur
                            }
                        }}
                    />
                )}
            />
            <OnboardingInputControl
                name={FormField.IsProvidingServicesToNotOwnedSites}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <InputableRadioGroup
                        slotProps={{
                            typography: {
                                children: 'Is this done manually or using a 3rd party tool?'
                            },
                            formControlLabel: {
                                disabled
                            },
                            radioGroup: {
                                'aria-labelledby': FormField.IsProvidingServicesToNotOwnedSites,
                                name: FormField.IsProvidingServicesToNotOwnedSites,
                                value: values[FormField.IsProvidingServicesToNotOwnedSites],
                                onChange: handleChange,
                                onBlur: handleBlur
                            },
                            textField: {
                                ...getFormInputProps(FormField.ProvidingServicesToNotOwnedSitesInput, form),
                                disabled,
                                name: FormField.ProvidingServicesToNotOwnedSitesInput,
                                value: values[FormField.ProvidingServicesToNotOwnedSitesInput],
                                label: 'IF YES: Which provider do you use for this?',
                                onChange: handleChange,
                                onBlur: handleBlur
                            }
                        }}
                    />
                )}
            />
            <OnboardingInputControl
                name={FormField.HasTangibleGoods}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <InputableRadioGroup
                        slotProps={{
                            typography: {
                                children: 'Do you have 24/7 customer support?'
                            },
                            formControlLabel: {
                                disabled
                            },
                            radioGroup: {
                                'aria-labelledby': FormField.HasTangibleGoods,
                                name: FormField.HasTangibleGoods,
                                value: values[FormField.HasTangibleGoods],
                                onChange: handleChange,
                                onBlur: handleBlur
                            },
                            textField: {
                                ...getFormInputProps(FormField.MarketingMethods, form),
                                disabled,
                                name: FormField.MarketingMethods,
                                value: values[FormField.MarketingMethods],
                                label: 'IF NO: Provide operational hours (e.g., “Mon–Sun 08:00–20:00 CET”)',
                                onChange: handleChange,
                                onBlur: handleBlur
                            }
                        }}
                    />
                )}
            />
        </OnboardingForm>
    );
};

export default MarketingWebsiteAndSupport;
